import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { fieldsAtencion } from './fieldsAtencion';

export const getByToken = async ( tokenAtencion ) => {
  const query = `                    
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          ${fieldsAtencion}
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;

    const data = response2.atcm[0];
    return data;

  } catch (error) {
    console.error("Error getAtencionById", error);
    return error;
  }
}